
export const overflow = {
  name: 'overflow'
}

export const overflowY = {
  name: 'overflow-y'
}

export const overflowX = {
  name: 'overflow-x'
}